export default __webpack_public_path__ + "static/transportation-passport-control-customer-feedback-d16651f0135cd3b8644ed82cda135e54.jpg";